<template>
  <div
    class="z-40 h-full overflow-auto shadow"
    style="width: 250px; background: #f6f7f8"
    v-show="activeCells.length > 0"
  >
    <div v-if="activeCells.length > 0">
      <div class="px-4 py-2 text-lg font-bold border-b">图形样式</div>
      <div v-if="activeCells[0].isVertex()">
        <div class="px-4 py-3 border-b">
          <div class="mb-2 font-bold">布局</div>
          <el-form label-position="left" label-width="50px" size="small">
            <el-form-item label="宽度">
              <el-input-number
                controls-position="right"
                v-model="positionModel.width"
                @change="
                  (val: number) => {
                    handleGeomertyChange('width', val)
                  }
                "
              />
              <span class="ml-1">px</span>
            </el-form-item>
            <el-form-item label="高度">
              <el-input-number
                controls-position="right"
                v-model="positionModel.height"
                @change="
                  (val: number) => {
                    handleGeomertyChange('height', val)
                  }
                "
              />
              <span class="ml-1">px</span>
            </el-form-item>
            <el-form-item label="x">
              <el-input-number
                controls-position="right"
                v-model="positionModel.x"
                @change="
                  (val: number) => {
                    handleGeomertyChange('x', val)
                  }
                "
              />
              <span class="ml-1">px</span>
            </el-form-item>
            <el-form-item label="y">
              <el-input-number
                controls-position="right"
                v-model="positionModel.y"
                @change="
                  (val: number) => {
                    handleGeomertyChange('y', val)
                  }
                "
              />
              <span class="ml-1">px</span>
            </el-form-item>
            <el-form-item label="旋转">
              <el-input-number
                controls-position="right"
                v-model="positionModel.rotate"
                @change="
                  (val: string) => {
                    handlePropChange('rotation', val)
                  }
                "
              />
              <span class="ml-1">°</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="px-4 py-3 border-b">
          <div class="mb-2 font-bold">文本</div>
          <el-form size="small">
            <el-form-item label="字体">
              <el-select
                v-model="textModel.fontFamily"
                @change="
                  (val: string) => {
                    handlePropChange('fontFamily', val)
                  }
                "
              >
                <el-option v-for="font in fonts" :label="font" :value="font">
                  <span :style="{ fontFamily: font }">{{ font }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="字号">
              <el-input-number
                controls-position="right"
                v-model="textModel.fontSize"
                @change="
                  (val: string) => {
                    handlePropChange('fontSize', val)
                  }
                "
              />
              <span class="ml-1">px</span>
            </el-form-item>
            <el-form-item label="颜色">
              <el-color-picker
                v-model="textModel.fontColor"
                @change="
                  (val: string) => {
                    handlePropChange('fontColor', val)
                  }
                "
              />
            </el-form-item>
            <el-form-item label="加粗">
              <el-switch
                v-model="textModel.bold"
                @change="
                  (val: string) => {
                    handlePropChange('bold', val)
                  }
                "
              />
            </el-form-item>
            <el-form-item label="倾斜">
              <el-switch
                v-model="textModel.italic"
                @change="
                  (val: string) => {
                    handlePropChange('italic', val)
                  }
                "
              />
            </el-form-item>
            <el-form-item label="下划线">
              <el-switch
                v-model="textModel.underline"
                @change="
                  (val: string) => {
                    handlePropChange('underline', val)
                  }
                "
              />
            </el-form-item>
            <el-form-item label="文本水平方向"
              ><el-select
                v-model="textModel.align"
                @change="
                  (val: string) => {
                    handlePropChange('align', val)
                  }
                "
              >
                <el-option
                  v-for="font in labelPosition"
                  :label="font.label"
                  :value="font.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="文本垂直方向">
              <el-select
                v-model="textModel.verticalLabelPosition"
                @change="
                  (val: string) => {
                    handlePropChange('verticalLabelPosition', val)
                  }
                "
              >
                <el-option
                  v-for="font in verticalLabelPosition"
                  :label="font.label"
                  :value="font.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="垂直方向">
              <el-select
                v-model="textModel.verticalAlign"
                @change="
                  (val: string) => {
                    handlePropChange('verticalAlign', val)
                  }
                "
              >
                <el-option
                  v-for="font in verticalLabelPosition"
                  :label="font.label"
                  :value="font.value"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="px-4 py-3 border-b">
          <div class="mb-2 font-bold">节点</div>
          <el-form size="small">
            <el-form-item label="字体">
              <el-select
                v-model="containerModel.headerFontFamily"
                @change="
                  (val: string) => {
                    handlePropChange('headerFontFamily', val)
                  }
                "
              >
                <el-option v-for="font in fonts" :label="font" :value="font">
                  <span :style="{ fontFamily: font }">{{ font }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="字号">
              <el-input-number
                controls-position="right"
                v-model="containerModel.headerFontSize"
                @change="
                  (val: string) => {
                    handlePropChange('headerFontSize', val)
                  }
                "
              />
              <span class="ml-1">px</span>
            </el-form-item>
            <el-form-item label="颜色">
              <el-color-picker
                v-model="containerModel.headerFontColor"
                @change="
                  (val: string) => {
                    handlePropChange('headerFontColor', val)
                  }
                "
              />
            </el-form-item>
            <el-form-item label="文本水平方向"
              ><el-select
                v-model="containerModel.headerAlign"
                @change="
                  (val: string) => {
                    handlePropChange('headerAlign', val)
                  }
                "
              >
                <el-option
                  v-for="font in labelPosition"
                  :label="font.label"
                  :value="font.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="文本垂直方向">
              <el-select
                v-model="containerModel.headerVerticalLabelPosition"
                @change="
                  (val: string) => {
                    handlePropChange('headerVerticalLabelPosition', val)
                  }
                "
              >
                <el-option
                  v-for="font in verticalLabelPosition"
                  :label="font.label"
                  :value="font.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="垂直方向">
              <el-select
                v-model="containerModel.headerVerticalAlign"
                @change="
                  (val: string) => {
                    handlePropChange('headerVerticalAlign', val)
                  }
                "
              >
                <el-option
                  v-for="font in verticalLabelPosition"
                  :label="font.label"
                  :value="font.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="边框颜色">
              <el-color-picker
                v-model="containerModel.strokeColor"
                @change="
                  (val: string) => {
                    handlePropChange('strokeColor', val)
                  }
                "
              ></el-color-picker>
            </el-form-item>
            <el-form-item label="头部背景颜色">
              <el-color-picker
                v-model="containerModel.fillColor"
                @change="
                  (val: string) => {
                    handlePropChange('fillColor', val)
                  }
                "
              ></el-color-picker>
            </el-form-item>
            <el-form-item label="主体背景颜色">
              <el-color-picker
                v-model="containerModel.swimlaneFillColor"
                @change="
                  (val: string) => {
                    handlePropChange('swimlaneFillColor', val)
                  }
                "
              ></el-color-picker>
            </el-form-item>
            <!-- <el-form-item label="圆角">
              <el-input-number
                controls-position="right"
                :min="0"
                v-model="containerModel.rounded"
                @change="
                  (val: number) => {
                    handlePropChange('rounded', val)
                  }
                "
              />
              <span class="ml-1">px</span>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
      <div v-if="activeCells[0].isEdge()">
        <div class="px-4 py-3 border-b">
          <div class="mb-2 font-bold">布局</div>
          <el-form size="small">
            <el-form-item label="连线类型">
              <el-select
                v-model="edgeConfig.dashed"
                @change="
                  (val: string) => {
                    handlePropChange('dashed', val)
                  }
                "
              >
                <el-option label="实线" value="0"></el-option>
                <el-option label="虚线" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="连线颜色">
              <el-color-picker
                v-model="edgeConfig.strokeColor"
                @change="
                  (val: string) => {
                    handlePropChange('strokeColor', val)
                  }
                "
              ></el-color-picker>
            </el-form-item>
            <el-form-item label="宽度">
              <el-input-number
                v-model="edgeConfig.strokeWidth"
                @change="
                  (val: string) => {
                    handlePropChange('strokeWidth', val)
                  }
                "
              />
            </el-form-item>
            <el-form-item label="连线样式">
              <el-select
                v-model="edgeConfig.edgeStyle"
                @change="
                  (val: string) => {
                    handlePropChange('edgeStyle', edgeStyles[val])
                  }
                "
              >
                <el-option
                  v-for="item in Object.keys(edgeStyles)"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="开始箭头">
              <el-select
                v-model="edgeConfig.startArrow"
                @change="
                  (val: string) => {
                    handlePropChange('startArrow',val)
                  }
                "
              >
                <el-option
                  v-for="item in arrows"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结束箭头">
              <el-select
                v-model="edgeConfig.endArrow"
                @change="
                  (val: string) => {
                    handlePropChange('endArrow',val)
                  }
                "
              >
                <el-option
                  v-for="item in arrows"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-empty v-else description="请选择图元" />
  </div>
</template>

<script setup lang="ts">
import { isNumber } from 'lodash'
import { mxCell, StyleMap } from 'mxgraph'
import { nextTick, onMounted, ref, shallowRef, unref, watch } from 'vue'
import mx from './factory'
import MyGraph from './graph'

const props = withDefaults(
  defineProps<{
    graph?: MyGraph
    showFormat: boolean
    handleGeomertyChange?: (
      cells: mxCell[],
      key: string,
      value: number | string
    ) => void
    handleStyleChange?: (
      cells: mxCell[],
      key: string,
      value: number | string | [string[], (string | null)[]]
    ) => void
  }>(),
  {
    showFormat: true
  }
)
watch(
  () => props.graph,
  () => {
    if (props.graph) {
      initFormat(props.graph)
    }
  }
)
const activeCells = shallowRef<mxCell[]>([])
const initFormat = (graph: MyGraph) => {
  graph.getSelectionModel().addListener(mx.mxEvent.CHANGE, () => {
    getActiveCells(graph)
  })
  graph.getModel().addListener(mx.mxEvent.CHANGE, () => {
    getActiveCells(graph)
  })
}

const getActiveCells = (graph: MyGraph) => {
  const cells = graph.getSelectionCells()
  if (cells.length > 0) {
    let firstType = cells[0].isVertex()
    const cell = cells[0]
    activeCells.value = cells.filter((ele) => firstType === ele.isVertex())
    const { width, height, x, y } = cell.geometry
    const styles = graph.getCellStyle(cell)
    if (cell.isVertex()) {
      positionModel.value = {
        width,
        height,
        rotate: styles.rotation ? styles.rotation : 0,
        x,
        y
      }
    } else {
      edgeConfig.value = {
        dashed: styles.dashed || '0',
        endArrow: styles.endArrow || 'none',
        startArrow: styles.startArrow || 'none',
        strokeColor: styles.strokeColor || '',
        strokeWidth: styles.strokeWidth || 1,
        edgeStyle: getEdgeStyles(styles)
      }
    }
    const o = getFontStyle(Number(styles.fontStyle) || 0)
    textModel.value = {
      fontFamily: styles.fontFamily || '',
      fontSize: Number(styles.fontSize) || 12,
      fontColor: styles.fontColor || '#00000',
      align: styles.align || 'center',
      verticalLabelPosition: styles.verticalLabelPosition || 'bottom',
      verticalAlign: styles.verticalAlign || 'bottom',
      ...o
    }
    containerModel.value = {
      headerFontFamily: styles.headerFontFamily || '',
      headerFontSize: Number(styles.headerFontSize) || 12,
      headerFontColor: styles.headerFontColor || '#fff',
      headerAlign: styles.headerAlign || 'center',
      headerVerticalLabelPosition:
        styles.headerVerticalLabelPosition || 'bottom',
      headerVerticalAlign: styles.headerVerticalAlign || 'bottom',
      strokeColor: styles.strokeColor || '',
      swimlaneFillColor: styles.swimlaneFillColor || '', //内容主体颜色
      fillColor: styles.fillColor || '', //头部颜色,
      rounded: Number(styles.rounded) || 0
    }
  } else {
    activeCells.value = []
  }
}

const positionModel = ref<{
  width: number
  height: number
  rotate: number
  x: number
  y: number
}>({
  width: 0,
  height: 0,
  rotate: 0,
  x: 0,
  y: 0
})

const fonts = [
  '黑体',
  '楷体',
  '宋体',
  '微软雅黑',
  'Arial',
  'Times New Roman',
  'Comic Sans MS',
  'Courier New',
  'Verdana',
  'Garamond',
  'Georgia',
  'Impact',
  'Tahoma',
  'Lucida Console'
]

const verticalLabelPosition = [
  { label: '顶部对齐', value: 'top' },
  { label: '底部对齐', value: 'bottom' },
  { label: '上下居中对齐', value: 'middle' }
]

const labelPosition = [
  { label: '左对齐', value: 'left' },
  { label: '居中', value: 'right' },
  { label: '右对齐', value: 'center' }
]

interface TextConfig {
  fontFamily: string
  fontSize: number
  fontColor: string
  bold: boolean
  align: string
  verticalLabelPosition: string
  italic: boolean
  underline: boolean
  verticalAlign: string
}

const textModel = ref<TextConfig>({
  fontFamily: '',
  fontSize: 0,
  fontColor: '',
  bold: false,
  align: '',
  verticalLabelPosition: '',
  italic: false,
  underline: false,
  verticalAlign: ''
})

interface ContainerConfig {
  headerFontFamily: string
  headerFontSize: number
  headerFontColor: string
  headerAlign: string
  headerVerticalLabelPosition: string
  headerVerticalAlign: string
  strokeColor: string
  fillColor: string
  swimlaneFillColor: string
  rounded: number
}
const containerModel = ref<ContainerConfig>({
  headerFontFamily: '',
  headerFontSize: 16,
  headerFontColor: '',
  headerAlign: '',
  headerVerticalLabelPosition: '',
  headerVerticalAlign: '',
  strokeColor: '',
  fillColor: '#fff',
  swimlaneFillColor: '',
  rounded: 0
})

enum fontStyle {
  'bold' = 1,
  'italic' = 2,
  'underline' = 4
}

const handlePropChange = (
  prop: string,
  value: number | string | [string[], (string | null)[]]
) => {
  const graph = props.graph
  if (!graph) return
  console.log(prop, value)
  if (Object.keys(fontStyle).includes(prop)) {
    const n = Object.keys(fontStyle).reduce((p, c) => {
      const num = textModel.value[c as unknown as 'fontSize']
        ? fontStyle[c as unknown as 'bold']
        : 0
      return num + p
    }, 0)

    mx.mxUtils.setCellStyles(
      graph.model,
      activeCells.value,
      'fontStyle',
      isNumber(n) ? `${n}` : n
    )
    props.handleStyleChange &&
      props.handleStyleChange(activeCells.value, 'fontStyle', n)
  } else {
    if (typeof value === 'number' || typeof value === 'string') {
      mx.mxUtils.setCellStyles(
        graph.model,
        activeCells.value,
        prop,
        isNumber(value) ? `${value}` : value
      )
      props.handleStyleChange &&
        props.handleStyleChange(activeCells.value, prop, value)
    } else if (typeof value === 'object') {
      value[0].forEach((ele, index) => {
        mx.mxUtils.setCellStyles(
          graph.model,
          activeCells.value,
          ele,
          value[1][index]
        )
      })
      props.handleStyleChange &&
        props.handleStyleChange(activeCells.value, '', value)
    }
  }
}

const handleGeomertyChange = (key: string, value: number) => {
  activeCells.value.forEach((ele) => {
    ele.geometry[key as unknown as 'x'] = value
    props.graph?.refresh(ele)
  })
  props.handleGeomertyChange &&
    props.handleGeomertyChange(activeCells.value, key, value)
}

const getFontStyle = (num: number) => {
  return {
    bold: num === 1 || num === 3 || num === 7 || num === 5 ? true : false,
    italic: num === 2 || num === 3 || num === 7 || num === 6 ? true : false,
    underline: num === 4 || num === 7 || num === 5 || num === 6 ? true : false
  }
}

const edgeStyles: Record<string, [string[], (string | null)[]]> = {
  直线: [
    [
      mx.mxConstants.STYLE_EDGE,
      mx.mxConstants.STYLE_ELBOW,
      mx.mxConstants.STYLE_CURVED,
      mx.mxConstants.STYLE_NOEDGESTYLE
    ],
    ['isometricEdgeStyle', null, null, null]
  ],
  折线: [
    [
      mx.mxConstants.STYLE_EDGE,
      mx.mxConstants.STYLE_CURVED,
      mx.mxConstants.STYLE_NOEDGESTYLE
    ],
    ['orthogonalEdgeStyle', null, null]
  ],

  水平折线: [
    [
      mx.mxConstants.STYLE_EDGE,
      mx.mxConstants.STYLE_ELBOW,
      mx.mxConstants.STYLE_CURVED,
      mx.mxConstants.STYLE_NOEDGESTYLE
    ],
    ['elbowEdgeStyle', null, null, null]
  ],
  垂直折线: [
    [
      mx.mxConstants.STYLE_EDGE,
      mx.mxConstants.STYLE_ELBOW,
      mx.mxConstants.STYLE_CURVED,
      mx.mxConstants.STYLE_NOEDGESTYLE
    ],
    ['elbowEdgeStyle', 'vertical', null, null]
  ],

  曲线: [
    [
      mx.mxConstants.STYLE_EDGE,
      mx.mxConstants.STYLE_ELBOW,
      mx.mxConstants.STYLE_CURVED,
      mx.mxConstants.STYLE_NOEDGESTYLE
    ],
    ['orthogonalEdgeStyle', null, '1', null]
  ]
}

const getEdgeStyles = (styles: StyleMap) => {
  const index = Object.values(edgeStyles).findIndex((ele) => {
    const obj: boolean[] = []
    ele[0].forEach((key, index) => {
      if (
        ele[1][index] === String(styles[key]) ||
        (ele[1][index] === null &&
          (styles[key] === undefined ||
            styles[key] === null ||
            String(styles[key]) === '0'))
      ) {
        obj.push(true)
      } else {
        obj.push(false)
      }
    })
    return !obj.includes(false)
  })
  if (index === -1) return '直线'
  return Object.keys(edgeStyles)[index]
}

const arrows: string[] = [
  'none',
  'classic',
  'open',
  'openThin',
  'block',
  'oval',
  'diamond',
  'diamondThin'
]
const edgeConfig = ref<{
  dashed: string
  endArrow: string
  startArrow: string
  strokeColor: string
  strokeWidth: number
  edgeStyle: string
}>({
  dashed: '0',
  endArrow: '',
  startArrow: '',
  strokeColor: '',
  strokeWidth: 1,
  edgeStyle: ''
})
</script>

<style scoped></style>
